module.exports = __webpack_public_path__ + "img/260.register_load.49e98901.svg";